/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./modalDisable.vue?vue&type=template&id=506af94c"
import script from "./modalDisable.vue?vue&type=script&lang=js"
export * from "./modalDisable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports